import React from 'react';
import { ROUTES } from '../../utils/constants';
import './Footer.css';

const Footer: React.FC = () => {
  const handleLegalClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    window.location.href = ROUTES.LEGAL;
  };

  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-links">
          <a
            href={ROUTES.LEGAL}
            onClick={handleLegalClick}
            className="footer-link"
          >
            Legal & Attribution
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
